export default "__VITE_ASSET__DJVleqd$__"